import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";

const Index = () => {
  return (
    <Layout>
      <Dashboard />
    </Layout>
  );
};

export default Index;
